// @ts-strict-ignore
import {Component, Input, OnInit} from "@angular/core";
import {CameraLayoutOptionsContainer} from "../../../../types/camera-layout-options";
import {BaseRecorderLayout} from "../base-recorder-layout";

@Component({
	selector: "sim-recorder-layout-bsss",
	templateUrl: "./recorder-layout-bsss.component.html",
	styleUrls: ["./recorder-layout-bsss.component.scss"],
	standalone: false,
})
export class RecorderLayoutBsssComponent extends BaseRecorderLayout implements OnInit {
	@Input() cameraLayoutOptionsContainer: CameraLayoutOptionsContainer;

	constructor() {
		super();
	}

	ngOnInit() {}
}
